import { render, staticRenderFns } from "./ChatOrderFreeProductItem.vue?vue&type=template&id=e744d8ae&scoped=true&"
import script from "./ChatOrderFreeProductItem.vue?vue&type=script&lang=js&"
export * from "./ChatOrderFreeProductItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderFreeProductItem.vue?vue&type=style&index=0&id=e744d8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e744d8ae",
  null
  
)

export default component.exports